var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControllerX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7600",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 9.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14,13.9a2,2,0,0,1-4,0c0-1.1,2-4,2-4S14,12.7,14,13.9Zm-1.1-.7a.5.5,0,1,0,.5.5A.472.472,0,0,0,12.9,13.2Z",
    transform: "translate(-10 -9.9)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,20.3A8.28,8.28,0,0,1,3.7,12,8.139,8.139,0,0,1,8.9,4.3a.731.731,0,0,1,1,.4.731.731,0,0,1-.4,1A6.585,6.585,0,0,0,5.2,12a6.8,6.8,0,0,0,13.6,0,6.951,6.951,0,0,0-4.4-6.4.7.7,0,0,1-.4-1,.7.7,0,0,1,1-.4A8.454,8.454,0,0,1,20.4,12,8.43,8.43,0,0,1,12,20.3Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,8a.789.789,0,0,1-.8-.8v-5a.789.789,0,0,1,.8-.8.736.736,0,0,1,.8.8v5A.789.789,0,0,1,12,8Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerX24);
export default __webpack_public_path__ + "static/media/controller-x24.eb03ac48cbc92ff531e91055711d97c8.svg";
export { ForwardRef as ReactComponent };